export const architectureEn = {
  architecturePage: {
    title: "Architecture & Integrations",
    subtitle: "Technical overview of Sentinel Crop's infrastructure, smart contracts, and provider integrations for COPA-COGECA presentation",
    downloadDiagrams: "Download Diagrams",
    providerIntegrations: "Provider Integrations Overview",
    providerIntegrationsDesc: "Real-time data flow from satellite providers to smart contracts on Base blockchain",
    dataFlow: "Provider Integrations Data Flow",
    weatherData: "Weather Data",
    climateAnalysis: "Climate Analysis",
    priceFeeds: "Price Feeds",
    edgeFunctions: "Edge Functions",
    dataProcessing: "Data Processing",
    aiAnalytics: "AI Analytics",
    riskAssessment: "Risk Assessment",
    monitoring: "Monitoring",
    surveillance: "24/7 Surveillance",
    smartContracts: "Smart Contracts",
    baseNetwork: "Base Network",
    userInterface: "User Interface",
    reactDashboard: "React Dashboard",
    smartContractsFlow: "Smart Contracts Flow on Base",
    smartContractsFlowDesc: "Detailed technical architecture of parametric insurance contracts and oracle integration",
    policyCreation: "Policy Creation Process",
    automatedMonitoring: "Automated Monitoring (Every 6 Hours)",
    queryCopernicus: "Query Copernicus",
    satelliteData: "Satellite Data",
    claimTrigger: "Claim Trigger Process",
    ndviThreshold: "NDVI Threshold",
    chainlinkOracle: "Chainlink Oracle",
    calculatePayout: "Calculate Payout",
    processClaim: "Process Claim",
    contractFeatures: "Smart Contract Features",
    eventArchitecture: "Event-only Architecture",
    noEthStorage: "No ETH Storage",
    transparentLogging: "Transparent Logging",
    oracleIntegration: "Oracle Integration",
    multiPolicySupport: "Multi-policy Support",
    smartContractArch: "Smart Contract Architecture",
    edgeFunctionsPipeline: "Edge Functions Pipeline",
    deploymentNetworks: "Deployment Networks",
    blockchainIntegration: "Blockchain Integration",
    technicalSpecs: "Technical Specifications",
    technicalSpecsDesc: "Key technical details for implementation and integration",
    blockchainLayer: "Blockchain Layer",
    dataSources: "Data Sources",
    infrastructure: "Infrastructure",
    performanceScalability: "Performance & Scalability",
    performanceScalabilityDesc: "Enterprise-grade performance for COPA-COGECA members",
    performanceMetrics: "Performance Metrics",
    scalabilityFeatures: "Scalability Features"
  }
};